import { useStoryblokStore } from '@/stores/StoryBlok.store'
import { usePageStore } from '@/stores/Page.store'
import { STATIC_PAGES } from '@/utils/constants/staticPages'
import { useRobotsRule } from '#imports'

const resolveRelations = [
  'page.breadcrumbs',
  'page.sidebarMenu',
  'page.other',
  'breadcrumbs.links',
  'sidebar-links.items',
  'silo.breadcrumbs',
  'silo-sections.sections',
  'silo-section.large',
  'silo-section.medium',
  'silo-section.small',
  'silo-item.link',
  'linkRef.links',
  'form-selector.backUrl',
  'info-block-cta.cta',
  'form-selector.backUrl',
  'links-grid.linksGridItems',
  'anchor-sections.sections'
]

const getStoryBlokData = async (slug: string) => {
  const runtimeConfig = useRuntimeConfig()
  const { $i18n } = useNuxtApp()

  const language = $i18n.locale.value === 'en' ? 'default' : $i18n.locale.value

  return await useAsyncStoryblok(
    slug,
    {
      version: runtimeConfig.public.env === 'development' ? 'draft' : 'published',
      language,
      resolve_relations: resolveRelations,
      resolve_links: 'story',
      resolve_assets: 1
    },
    {
      resolveRelations: resolveRelations,
      resolveLinks: 'story'
    }
  )
}

// Potential problem: on link click reddirect for page in different language this middleware will fail
// i.e. /lv/noteikumi-un-regulas -> /en/rules-and-regulations
export default defineNuxtRouteMiddleware(async (to) => {
  const storyblokStore = useStoryblokStore()
  const pageStore = usePageStore()

  const sbPreview = !!to.query?._storyblok || false

  const { params, path } = to

  let slug: string | string[] = params.slug

  if (Array.isArray(slug)) {
    slug = slug.join('/')
  }

  const isStaticPage = STATIC_PAGES.some((page) => path.includes(page))

  if (isStaticPage) {
    return
  }

  try {
    if (!slug && sbPreview) {
      slug = path
    }

    if (!slug) {
      slug = 'index'
    }

    const response = await getStoryBlokData(slug)

    if (sbPreview) {
      slug = slug.startsWith('/') ? slug.slice(1) : slug
    }

    if (!response?.value?.full_slug?.includes(slug)) {
      useRobotsRule(false)
      throw createError({
        statusCode: 404,
        statusMessage: 'global.error.pageNotFound',
        fatal: true
      })
    }

    useRobotsRule(true)

    storyblokStore.data = response.value

    if (!response.value.translated_slugs.length) {
      return
    }

    const defaultSlug = {
      lang: 'en',
      name: response.value?.name || '',
      path: response.value?.default_full_slug || '/',
      published: true
    }

    pageStore.setSlugs(response.value?.translated_slugs || [], [defaultSlug])

    return
  } catch (e) {
    useRobotsRule(false)
    throw createError({
      statusCode: 404,
      statusMessage: 'global.error.pageNotFound',
      fatal: true
    })
  }
})
